import { memo } from 'react';
import PropTypes from 'prop-types';
import Text from '@/components/component-library/Text';
import { classes } from '@/helpers/styling';
import Link from '@/components/component-library/Link';

const Option = ({
  id,
  value,
  selected,
  onClick,
  href,
  OptionComponent
}) => {
  return (
    <Link
      className={ classes('scrolling-selector-h__option', { '--is-selected': selected }) }
      href={ href }
      onClick={ onClick }
    >
      { OptionComponent
        ? <OptionComponent id={ id } selected={ selected } value={ value } />
        : (
          <Text bold className='scrolling-selector-h__option-text' useHeaderFont>
            { value }
          </Text>
        ) }
    </Link>
  );
};

Option.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  OptionComponent: PropTypes.element,
  id: PropTypes.string.isRequired
};

Option.defaultProps = {
  selected: false,
  onClick: undefined,
  href: '',
  OptionComponent: undefined
};

export default memo(Option);